import { useEffect, useState } from 'react'
import Lottie from 'lottie-react'
import { Outlet } from 'react-router-dom'

import Header from '@/components/ui/CommercialCombined//Header'
import { getEmail } from '@/api/commercialCombined'
import { loaderStore } from '@/store/LoaderStore'
import animationData from '@/assets/images/cg_loading.json'

const brokerBaseURL = import.meta.env.VITE_BROKER_LOGIN_URL

const BrokerRoute = () => {
  const [authed, setAuthed] = useState(false)
  const [loading, setLoading] = useState(true)

  const { quotesLoading } = loaderStore()

  useEffect(() => {
    getEmail()
      .then(({ data }) => {
        setLoading(false)
        sessionStorage.setItem('authBroker', JSON.stringify(data.email))
        setAuthed(true)
        // we authenticate to the form in here
      })
      .catch(() => {
        setAuthed(false)
      })
  }, [])

  if (loading) {
    return <div>Authenticating...</div>
  }

  if (!authed) {
    document.location.href = `${brokerBaseURL}broker/login`
    return <div>Redirecting...</div>
  }

  return (
    <>
      <Header />
      {quotesLoading && (
        <div
          className="position-absolute h-100 w-100 top-0"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.6)',
            zIndex: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Lottie
            animationData={animationData}
            loop
            autoplay
            style={{ height: 150, width: 150 }}
          />
        </div>
      )}

      <Outlet />
    </>
  )
}

export default BrokerRoute
